<script lang="ts">
	//UI
	import { OutlineButton, PlusIcon } from "@hitit/new_ui";

	import Item from "./Item.svelte";
	//Utils
	import { createEventDispatcher } from "svelte";
	import { sortableAction } from "@hitit/hub/src/v7/utils";
	import type { SortableEvent } from "sortablejs";
	//Types
	type Item = {
		title: string;
		displaySort: number;
		id: string;
		question: string;
		documentState: string;
	};

	//Props
	export let addButtonHide = false;
	export let editmode = false;
	export let items: Item[] = [];
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	$: sortableOption = {
		group: {
			name: "faqs",
			put: true,
			pull: false,
		},
		disabled: !editmode,
		delay: 50,
		avoidImplicitDeselect: true,
		animation: 150,
		swapThreshold: 0.65,
		forceFallback: true,
		ghostClass: "sortable-ghost",
		dragClass: "sortable-drag",
		draggable: ".item",
		filter: "#add-item",
		preventOnFilter: false,
		onSort,
		onStart,
		onEnd,
	};
	//Functions
	function onSort(event: SortableEvent) {
		const { oldIndex, newIndex } = event;

		dispatch("UPDATED_ITEM_DISPLAY_SORT", { oldIndex, newIndex });
	}
	function onStart() {
		document.body.classList.add("dragging");
	}
	function newItemClickHandler() {
		dispatch("NEW_ITEM");
	}

	function onEnd() {
		document.body.classList.remove("dragging");
	}
	//Do
</script>

<div class="container" use:sortableAction={sortableOption}>
	{#each items as item (item.id)}
		<Item
			on:ITEM_CLICK
			on:ITEM_DELETE
			editmode={editmode}
			id={item.id}
			question={item.question}
			displaySort={item.displaySort}
			documentState={item.documentState} />
	{/each}
	{#if editmode && addButtonHide === false}
		<div class="add-item">
			<OutlineButton
				noneBordercolor
				fitmode
				nonePadding
				on:click={newItemClickHandler}
			>
				<div class="inner">
					<div class="add-sign">
						<PlusIcon thin />
					</div>
				</div>
			</OutlineButton>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
		.add-item {
			box-sizing: border-box;
			border: 1px solid #bcbfc3;
			border-radius: 5px;
			width: 100%;
			max-width: 100%;
			height: 78px;
			.inner {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.add-sign {
				width: 35px;
				height: 54px;
			}
		}
	}
	@include DesktopSize {
		.container {
			overflow-y: auto;
			padding-right: 5px;
			box-sizing: border-box;
			gap: 20px;
			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}
		}
	}
</style>
